module.exports = __webpack_public_path__ + "static/qrPaymentMobile_en-51154155c0e100d4f43cc9ed9506da90.png";